import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { routes } from "./app.routes";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideToastr } from "ngx-toastr";
import { ConfirmationService } from "primeng/api";
import { jwtInterceptor } from "../Utils/_interceptors/jwt.interceptor";
import { providePrimeNG } from "primeng/config";
import Lara from "@primeuix/themes/lara";
import { definePreset } from '@primeuix/themes';
const DropAddyPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50:  '{rose.50}',
      100: '{rose.100}',
      200: '{rose.200}',
      300: '{rose.300}',
      400: '{rose.400}',
      500: '#ff5c8d',
      600: '#e0456f',
      700: '#bf3057',
      800: '{rose.800}',
      900: '{rose.900}',
      950: '{rose.950}',
    },
  },
});
import { networkErrorInterceptor } from "../Utils/_interceptors/networ-error.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([
      networkErrorInterceptor,
      jwtInterceptor
    ])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
         preset: DropAddyPreset,
        options: {
          prefix: "p",
          darkModeSelector: false,
          cssLayer: false,
        },
      },
    }),
    provideToastr(),
    ConfirmationService,
  ],
};
